import { CancelToken } from "axios";
import api from "../api";

// API path to the media service
const path = "media";

/**
 * Get a form instance
 *
 * @param instanceId form instance id
 */
const create = async (name: string, type: string, cancelToken?: CancelToken) =>
	api.request({
		method: "POST",
		url: path,
		data: { name, type },
		cancelToken,
	});

export default { create };
